import { type ReactNode } from 'react';
import type { Quote } from 'receivable-invoices-js/react/api/models/quote';
import type { CreditNote } from 'receivable-invoices-js/react/api/models/credit-note';
import type { ReceivableInvoice } from 'receivable-invoices-js/react/api/models/receivable-invoice';
import type { PaymentLink } from 'receivable-invoices-js/react/api/models/payment-link';
import type { PaymentPollingStatus } from 'receivable-invoices-js/react/routes/invoices/index/hooks/use-status-polling';
import { QuoteContent } from '../quote-content';
import { CreditNoteContent } from '../credit-note-content';
import { ReceivableInvoiceContent } from '../receivable-invoice-content';
import { PaymentLinkContent } from '../payment-link-content';

interface MainContentProps {
  document: Quote | CreditNote | ReceivableInvoice;
  type?: 'invoice' | 'quote' | 'credit-note';
  isMobile: boolean;
  paymentLink?: PaymentLink | null;
  paymentPollingStatus?: PaymentPollingStatus;
  clientPortalId?: string;
  downloadAll: () => Promise<void>;
  hasAttachments: boolean;
  isClientPortalEnabled?: boolean;
}

export function MainContent({
  document,
  type,
  isMobile,
  paymentLink,
  paymentPollingStatus,
  clientPortalId,
  downloadAll,
  hasAttachments,
  isClientPortalEnabled,
}: MainContentProps): ReactNode {
  if (type === 'credit-note') {
    return <CreditNoteContent document={document as CreditNote} />;
  }
  if (type === 'quote') {
    return (
      <QuoteContent
        clientPortalId={clientPortalId}
        document={document as Quote}
        isClientPortalEnabled={isClientPortalEnabled}
        isMobile={isMobile}
      />
    );
  }
  if (paymentLink) {
    return (
      <PaymentLinkContent
        clientPortalId={clientPortalId}
        document={document as ReceivableInvoice}
        downloadAll={downloadAll}
        hasAttachments={hasAttachments}
        isClientPortalEnabled={isClientPortalEnabled}
        paymentLink={paymentLink}
        paymentPollingStatus={paymentPollingStatus}
      />
    );
  }

  return (
    <ReceivableInvoiceContent
      document={document as ReceivableInvoice}
      downloadAll={downloadAll}
      hasAttachments={hasAttachments}
    />
  );
}
